<template>
  <div class="app-container">
    <CrudTable entity="Penalty" :columns="columns" :on-row-dbl-click="() => {}" disable-filtering />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'ipAddress',
        { field: 'handedOutAtUtc', label: 'penalty.handedOutAtUtc', type: 'dateTime' },
        { field: 'penaltyType', label: 'penalty.penaltyType' },
        { field: 'penaltyPoints', label: 'penalty.penaltyPoints' }
      ]
    };
  }
};
</script>

<style scoped></style>
